import React from "react";
import { useDocumentTitle, isMobile } from "@/utils";
import styled from "@emotion/styled";
import Homepc from "./pc";
import Homemobile from "./mobile";
function Home(props) {
    const {title} = props;
    useDocumentTitle(title);
    console.log(45677)
 
    return (
        <ContainerContent>
            {isMobile()?<Homemobile></Homemobile>:<Homepc></Homepc>}
        </ContainerContent>
    );
}
const ContainerContent = styled.div`
    width: 100%;
    height: 100%;
`;
export default Home;
